/*
 *
 * OperationPayToCardDetail
 *
 * @version 1.0.0
 * @author Davide Polci
 * @since 19-Oct-2026
 */

import { connect } from 'react-redux'
import OperationPayToCardDetail from './OperationPayToCardDetail'

const mapDispatchToProps = {}

const mapStateToProps = (state) => ({
  info: state.operations?.operation?.additionalData || null,
  isLoading: state.loading.local_OperationDetails || false
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(OperationPayToCardDetail)
